let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7V296")).then(() => parcelRequire('i6qli'));